export default __webpack_public_path__ + "static/media/background.4635d9dc.jpeg";